// Resolution scaling utility based on design resolution (2560x1440)
// WScale = ActualWidth / DesignWidth
// HScale = ActualHeight / DesignHeight

import { useState, useEffect } from 'react';

const DESIGN_WIDTH = 2560;
const DESIGN_HEIGHT = 1440;

// Calculate initial scale synchronously to avoid flash
const getInitialScale = () => {
  if (typeof window === 'undefined') {
    return { w: 1, h: 1 };
  }
  return {
    w: window.innerWidth / DESIGN_WIDTH,
    h: window.innerHeight / DESIGN_HEIGHT,
  };
};

export function useScale() {
  const [scale, setScale] = useState(getInitialScale);

  useEffect(() => {
    const calculateScale = () => {
      const wScale = window.innerWidth / DESIGN_WIDTH;
      const hScale = window.innerHeight / DESIGN_HEIGHT;

      setScale({
        w: wScale,
        h: hScale,
      });
    };

    // Recalculate on resize
    window.addEventListener('resize', calculateScale);

    return () => window.removeEventListener('resize', calculateScale);
  }, []);

  return scale;
}

// Helper to scale a value by width
export const scaleW = (value: number, wScale: number) => value * wScale;

// Helper to scale a value by height
export const scaleH = (value: number, hScale: number) => value * hScale;

// Helper to get scaled dimensions
export const scaleDimensions = (
  width: number,
  height: number,
  wScale: number,
  hScale: number
) => ({
  width: width * wScale,
  height: height * hScale,
});
